import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children } from "react";
import Icon from "../../../../../base/icons/icon/index.js";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import * as S from "./styled.js";
const BenefitsCardMobile = ({ items =[]  })=>{
    if (!items.length) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(S.BenefitsCardWrapper, {
        "data-testid": "BenefitsCard",
        children: [
            /*#__PURE__*/ _jsx(S.BenefitsCardTitle, {
                "data-testid": "Title",
                children: /*#__PURE__*/ _jsx(Icon, {
                    className: "nico-circle-check"
                })
            }),
            /*#__PURE__*/ _jsx(S.Content, {
                className: "benefits-card-content",
                children: Children.toArray(items.map((item)=>/*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                        content: item
                    })))
            })
        ]
    });
};
export default BenefitsCardMobile;

//# sourceMappingURL=index.js.map